/**
 * Build-time configuration.
 *
 * The client id is a public OAuth identifier and is meant to ship in the bundle
 * — the PIN flow uses no client secret, which is precisely what allows a
 * browser-only app. Nothing secret belongs in this file or anywhere the build
 * can reach.
 */
export const CLIENT_ID = import.meta.env["VITE_SIMKL_CLIENT_ID"] ?? "";

/*
 * Notifications.
 *
 * Written here rather than read from the environment because both values are
 * public by construction: the Worker URL is a hostname anyone can resolve, and
 * a VAPID public key is handed to every push service that accepts one of our
 * subscriptions. Making them build variables would mean configuring Cloudflare
 * Pages to inject two values that are printed in the bundle anyway.
 *
 * The matching VAPID private key is a Worker secret and never reaches here.
 */
export const WORKER_URL = "https://tv-tracker-notify.joacogrimoldi.workers.dev";
export const VAPID_PUBLIC_KEY =
  "BG1N2Khks6u4vkmSPzLxETsoNyD9iOxa891Pxltuk3FTU6-ssqDvdU_ezD9n8wj1EPqw2Kzbwsm-qyTF5ZDjWLY";
export const APP_NAME = "tv-tracker";
export const APP_VERSION = "0.1.0";

if (CLIENT_ID.length === 0) {
  throw new Error(
    "VITE_SIMKL_CLIENT_ID is not set. Copy .env.example to .env and add your Simkl client id.",
  );
}
